// QA environment
// export const SERVER_HOST = 'http://localhost:8081';
// export const CORP_ID = 'ding04ea7fe3efbc6cc7ffe93478753d9884';

// PROD environment
export const SERVER_HOST = '/api';
export const CORP_ID = 'ding02c5d22620d3a8db35c2f4657eb6378f';
